export default "__VITE_ASSET__Cg1wwMJD__"